import * as React from 'react'

import { getStudent }    from '../../project-utils'
import InjectAccountType from '../atoms/InjectAccountType'

const StudentWording = () => {
  return (
    <InjectAccountType>
      {({ accountType }) => <>{getStudent(accountType)}</>}
    </InjectAccountType>
  )
}

export default StudentWording



// WEBPACK FOOTER //
// ./src/components/dynamic-project-wording/StudentWording.tsx